import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, MessageCircle, Instagram } from "lucide-react";
import { COMPANY, SERVICES } from "@/data/services";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-forest text-white/80 mt-20">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-12 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src="/logo-white.png"
              alt="Perspective Assurance"
              className="h-12 w-auto mb-6"
              loading="lazy"
            />
            <p className="text-sm leading-relaxed mb-6">
              Votre courtier de confiance à Lyon. Conseil personnalisé, accompagnement humain, garanties sur mesure.
            </p>
            <div className="flex gap-3">
              <a href={COMPANY.whatsapp} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" aria-label="WhatsApp" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-terracotta hover:border-terracotta">
                <MessageCircle className="w-4 h-4" />
              </a>
              <a href={COMPANY.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" aria-label="Instagram" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-terracotta hover:border-terracotta">
                <Instagram className="w-4 h-4" />
              </a>
              <a href={`mailto:${COMPANY.email}`} data-testid="footer-email-icon" aria-label="Email" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-terracotta hover:border-terracotta">
                <Mail className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-display text-lg mb-5">Nos services</h4>
            <ul className="space-y-3">
              {SERVICES.map(s => (
                <li key={s.slug}>
                  <Link to={`/${s.slug}`} data-testid={`footer-service-${s.slug}`} className="text-sm hover:text-white transition-colors">
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Liens */}
          <div>
            <h4 className="text-white font-display text-lg mb-5">Informations</h4>
            <ul className="space-y-3">
              <li><Link to="/a-propos" className="text-sm hover:text-white" data-testid="footer-about">À propos</Link></li>
              <li><Link to="/blog" className="text-sm hover:text-white" data-testid="footer-blog">Blog & expertise</Link></li>
              <li><Link to="/contact" className="text-sm hover:text-white" data-testid="footer-contact">Contact & devis</Link></li>
              <li><Link to="/mentions-legales" className="text-sm hover:text-white" data-testid="footer-legal">Mentions légales</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-display text-lg mb-5">Nous contacter</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-terracotta flex-shrink-0" />
                <span>{COMPANY.address}</span>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-0.5 text-terracotta flex-shrink-0" />
                <a href={`tel:${COMPANY.phone}`} data-testid="footer-phone" className="hover:text-white">{COMPANY.phoneDisplay}</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-0.5 text-terracotta flex-shrink-0" />
                <a href={`mailto:${COMPANY.email}`} data-testid="footer-email" className="hover:text-white break-all">{COMPANY.email}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-14 pt-6 flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="text-xs text-white/50">© {new Date().getFullYear()} Perspective Assurance. Tous droits réservés.</p>
          <p className="text-xs text-white/50">Courtier en assurances — ORIAS — Lyon, France</p>
        </div>
      </div>
    </footer>
  );
}
